import Color from 'color';
import constants from '../constants';

class Renderer {
  constructor(canvas, pointRenderer, pointDimensions, pointSize) {
    this.canvas = canvas;
    this.pointRenderer = pointRenderer;
    this.pointDimensions = pointDimensions;
    this.pointSize = pointSize;
    this.matrix = null;
  }

  setCanvasDimensions(width, height) {
    this.pixelDimensions = { x: width, y: height };
    this.canvas.width = width;
    this.canvas.height = height;

    this.pixelsToDraw = 'all';
    this._doDrawing();
  }

  setMatrix(matrix) {
    if (this.matrix !== null && this.matrix.length === matrix.length && this.matrix[0].length === matrix[0].length) {
      this.pixelsToDraw = [];
      for (let i = 0; i < matrix.length; i++) {
        for (let j = 0; j < matrix[i].length; j++) {
          if (matrix[i][j].rgbNumber() !== this.matrix[i][j].rgbNumber()) {
            this.pixelsToDraw.push({ x: j, y: i });
          }
        }
      }
    } else {
      this.pixelsToDraw = 'all';
    }

    this.matrix = matrix;
    this._doDrawing();
  }

  // =========================================================================
  // Helper methods
  // =========================================================================

  _doDrawing() {
    if (this.matrix) {
      const context = this.canvas.getContext('2d');
      this._drawMatrix(context);
    }
  }

  _drawMatrix(context) {
    const drawingDimensions = {
      x: this.pointDimensions.x * this.pointSize,
      y: this.pointDimensions.y * this.pointSize
    };
    const renderOffset = {
      x: Math.floor((this.pixelDimensions.x - drawingDimensions.x) / 2),
      y: Math.floor((this.pixelDimensions.y - drawingDimensions.y) / 2)
    };

    if (this.pixelsToDraw === 'all') {
      for (let i = 0; i < this.matrix.length; i++) {
        for (let j = 0; j < this.matrix[i].length; j++) {
          this._drawPoint(context, renderOffset, this.matrix[i][j], j, i);
        }
      }
    } else {
      this.pixelsToDraw.forEach((pixel) => {
        this._drawPoint(context, renderOffset, this.matrix[pixel.y][pixel.x], pixel.x, pixel.y);
      });
    }
  }

  _drawPoint(context, renderOffset, color, x, y) {
    const isOnEdge = !(x > 0 && x < this.matrix[0].length - 1 && y > 0 && y < this.matrix.length - 1);

    this.pointRenderer.renderPoint(context, isOnEdge ? Color(constants.graphics.BACKGROUND_COLOR) : color, {
      x: renderOffset.x + this.pointSize * x,
      y: renderOffset.y + this.pointSize * y,
    });
  }
}

export default Renderer;



// WEBPACK FOOTER //
// ./src/visuals/Renderer.js